import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import parse from 'html-react-parser';

import useClientMediaQuery from 'utils/useClientMediaQuery';

const ContentBox = ({ title, content, displayOnLeft }) => {
    const theme = useTheme();

    const matchDownSm = useClientMediaQuery(theme.breakpoints.down('md'), { defaultMatches: false });

    return (
        <Box
            sx={(t) => ({
                display: 'flex',
                flexFlow: 'column',
                marginLeft: displayOnLeft ? 0 : '40px',
                marginRight: displayOnLeft ? '40px' : 0,
                marginTop: '-5px',
                [t.breakpoints.down('md')]: {
                    marginTop: 0,
                    marginLeft: 0,
                    marginRight: 0,
                    flex: 1
                }
            })}
        >
            <Typography
                sx={(t) => ({
                    background: displayOnLeft
                        ? 'linear-gradient(-90deg, #FCB336 0%, #E15C12 44.5%)'
                        : 'linear-gradient(90deg, #E15C12 0%, #FCB336 44.5%);',
                    fontSize: '24px',
                    '-webkit-background-clip': 'text',
                    '-webkit-text-fill-color': 'transparent',
                    fontWeight: 600,
                    lineHeight: '100%',
                    marginBottom: matchDownSm ? '8px' : '16px',
                    textAlign: displayOnLeft ? 'right' : 'left',
                    [t.breakpoints.down('md')]: {
                        fontSize: '16px'
                    }
                })}
            >
                {title}
            </Typography>
            <Box
                sx={(t) => ({
                    width: '100%',
                    maxWidth: '420px',
                    padding: '16px 24px',
                    borderRadius: '20px',
                    boxShadow: '0px 10px 24px 0px #948B8033',
                    bgcolor: '#FFFFFF',
                    alignSelf: displayOnLeft ? 'flex-end' : 'flex-start',
                    [t.breakpoints.down('md')]: {
                        padding: '12px 16px'
                    }
                })}
            >
                <Typography
                    sx={(t) => ({
                        fontSize: '18px',
                        fontWeight: 400,
                        color: '#787878',
                        textAlign: displayOnLeft ? 'right' : 'left',
                        [t.breakpoints.down('md')]: {
                            fontSize: '14px'
                        }
                    })}
                >
                    {parse(content)}
                </Typography>
            </Box>
        </Box>
    );
};

export default ContentBox;
